import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '../../config';
import { FarmerLocation } from './locations.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/location');

export const getLocationsList = actionCreator.async<void, any[]>('GET_LOCATIONS_LIST');
export const createLocation = actionCreator.async<Partial<FarmerLocation>, FarmerLocation>('CREATE_LOCATION');
export const editLocation = actionCreator.async<Partial<FarmerLocation>, FarmerLocation>('EDIT_LOCATION');
export const deleteLocation = actionCreator.async<string, void>('DELETE_LOCATION');
